module.exports = __webpack_public_path__ + "static/media/02 Generali Gospodarstwo Rolne Karta produktu.d98975eb.pdf";